<template>
  <div class="spr-simple-checkbox">
    <div v-show="readMode && activated">
        <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="description-title">{{ $t(toCamelCase(value.translationKey)) }}</div>
      <ul class="description">
        <li v-for="(line, index) in descriptionLines" :key="index">{{ line }}</li>
      </ul>
    </div>
    <div v-show="!readMode">
      <input :id="_uid" 
      :checked="activated"
      type="checkbox" 
      @change="updateValue">
      
      <label :for="_uid">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span>{{ $t(toCamelCase(value.translationKey)) }}</span>
      </label>
      <div v-if="activated" class="activity-details">
        <forminput
            :key="`contactinfo.title_${value.activityTypeId}`"
            v-model="value.description"
            compact
            :title="$t('friendshipAdmin.descriptionTitle')"
            :hint="$t('userAdmin.friendshipGroupContactTitle')"
          />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { FriendManagementGroupActivityDto } from '@/types';
  import Vue from 'vue'
  import stringhelper from '@/helpers/stringhelper'
  import forminput from '@/components/SPRSimpleTextArea.vue'

  export default Vue.extend({
    name: 'SprSimpleNumberCheckbox',
    components: {
      forminput
    },
    props: {
      value: {
        type: Object as () => FriendManagementGroupActivityDto,
        default: () => {
          return {
            activityTypeId: 0,
            description: '',
            friendManagementGroupId: 0,
            name: '',
            translationKey: ''
          } as FriendManagementGroupActivityDto
          
        }
      },
      friendManagementGroupId: {
        type: Number,
        required: true
      },
      readMode: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      activated() : boolean {
        return this.value.friendManagementGroupId !== 0
      },
      descriptionLines() : string[] {
        return this.value.description.split('\n').filter(line => line.trim() !== '');
      }
    },
    methods: {
      emptyFriendManagementGroup() : FriendManagementGroupActivityDto {
        return {
            activityTypeId: 0,
            description: '',
            friendManagementGroupId: 0,
            name: '',
            translationKey: ''
          } as FriendManagementGroupActivityDto
      },
      updateValue: function (target) {
        if (target.target.checked) {
          this.value.friendManagementGroupId = this.friendManagementGroupId
        } else {
          this.value.friendManagementGroupId = 0
        }
        this.$emit('changed', this.value, target.checked)
      },
      toCamelCase(str: string): string {
        // split the string by dot, and then join parts with a dot after applying toCamelCase to each Element
        return str.split('.').map(s => stringhelper.toCamelCase(s)).join('.')
      }
    }
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.spr-simple-checkbox {
  .description-title {
    font-weight: normal;
    font-family: "Signa-Bold", Sans-Serif;
    font-size: 16px;
    letter-spacing: 0.3px;
  }
  .description {
    list-style-type: disc;
    padding-left: 1.5em;
    margin: 0;
    font-family: inherit; // Ensure the font matches the current font
    list-style-position: inside; // Ensure bullets are inside the list item
  }

  .description li {
    white-space: pre-wrap; // Preserve newlines and ensure long lines break correctly
  }

  /* hiding the initial actual checkbox */
  input[type="checkbox"]:not(:checked),
  input[type="checkbox"]:checked {
    position: absolute;
    left: -9999px;
  }

  /* the actual label styling */
  input[type="checkbox"]:not(:checked) + label,
  input[type="checkbox"]:checked + label {
    position: relative;
    padding-left: 1.95em;
    cursor: pointer;
  }

  /* checkbox aspect */
  input[type="checkbox"]:not(:checked) + label:before,
  input[type="checkbox"]:checked + label:before {
    content: '';
    position: absolute;
    left: 0; top: 0;
    width: 1.5em;
    height: 1.5em;
    border: 2px solid #ccc;
    background: #fff;
    border-radius: 4px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,.1);
  }
  /* checked mark aspect */
  input[type="checkbox"]:not(:checked) + label:after,
  input[type="checkbox"]:checked + label:after {
    content: '✓';
    position: absolute;
    top: .2em;
    left: .4em;
    font-size: 1.1em;
    line-height: 0.8;
    color: $brand-red;
    transition: all .2s;
  }
  /* checked mark aspect changes */
  input[type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  input[type="checkbox"]:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }
  /* disabled checkbox */
  input[type="checkbox"]:disabled:not(:checked) + label:before,
  input[type="checkbox"]:disabled:checked + label:before {
    box-shadow: none;
    border-color: #bbb;
    background-color: #ddd;
  }
  input[type="checkbox"]:disabled:checked + label:after {
    color: #999;
  }
  input[type="checkbox"]:disabled + label {
    color: #aaa;
  }

  /* accessibility */
  input[type="checkbox"]:checked:focus + label:before,
  input[type="checkbox"]:not(:checked):focus + label:before {
    border: 2px solid $brand-red;
  }

  &.validation-error {
    label {
      color: red;
    }
  }
}
</style>
